import { FC, useMemo } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Dropdown, DropdownInput, DropdownMenu, DropdownOption } from '@bonusly/design-system';

const frequencies = ['first', 'second', 'third', 'fourth', 'last'];

export const OccurrenceInput: FC = () => {
	const { t } = useTranslation('one_on_ones');
	const { field } = useController({ name: 'occurrenceInMonth' });
	const {
		formState: { errors: formErrors },
	} = useFormContext();
	const day = useWatch({ name: 'dayOfWeek' });

	const options = useMemo(() => {
		const selectedDayName = t(`schedule_day_of_week_options.${day}`);

		return frequencies.map((option) => ({
			label: t(`meeting.modal.form.cadence.monthly_${option}`, {
				day: selectedDayName,
			}),
			value: option,
		}));
	}, [day, t]);

	return (
		<Box flex="1 1 50%">
			<Dropdown
				matchWidth={true}
				onChange={field.onChange}
				renderOption={(value) => {
					const selected = options.find((o) => o.value === value);
					return <>{selected?.label}</>;
				}}
				value={field.value}
			>
				<DropdownInput 
					data-testid="occurrence-input" 
					minW={0} 
					flexGrow={1} 
					width="full" 
					borderColor={formErrors && formErrors.occurrenceInMonth ? 'error.inputBorder' : 'border.default'}
				/>
				<DropdownMenu zIndex="popover">
					{options.map((option) => (
						<DropdownOption key={option.value} value={option.value}>
							{option.label}
						</DropdownOption>
					))}
				</DropdownMenu>
			</Dropdown>
		</Box>
	);
};
